<template lang="pug">
  #plan-table(v-cloak)
    .plan-table(v-if="planTableModel != null")
      .thead
        .header-line
          .th.billing-type.no-bottom-border プラン名
          .th.free-rate(v-show="showFreePlan") 無料プラン
          .th(:class="{ 'flat-rate': showFreePlan, 'flat-rate-lg': !showFreePlan }") 固定料金プラン
        .header-line
          .th.billing-type
          .th.plan-name(v-show="showFreePlan") フリー
          .th(:class="{ 'plan-name': showFreePlan, 'plan-name-lg': !showFreePlan }") ライト
          .th(:class="{ 'plan-name': showFreePlan, 'plan-name-lg': !showFreePlan }") ベーシック
        .header-line
          .th.billing-type プラン特長
          .th.plan-description(v-show="showFreePlan")
            .description-text.text-left.align-self-start
              span 下記が無料で使用可能
              br
              span.key-color ✔ ご家族への連絡
              br
              span.key-color ✔ 面会予約
              br
              span.key-color ✔ オンライン面会
          .th(:class="{ 'plan-description': showFreePlan, 'plan-description-lg': !showFreePlan }")
            .description-text.text-left.align-self-start(v-if="showFreePlan")
              span フリーの機能に加えて
              br
              span.key-color ✔ 写真／動画の送信
              br
              span.key-color ✔ グループ管理
            .description-text-lg.text-left.align-self-start(v-else)
              span.key-color ✔ ご家族への連絡
              br
              span.key-color ✔ 写真／動画の送信
              br
              span.key-color ✔ 面会予約、オンライン面会
              br
              span.key-color ✔ グループ管理
          .th(:class="{ 'plan-description': showFreePlan, 'plan-description-lg': !showFreePlan }")
            .text-left.align-self-start(:class="{ 'description-text': showFreePlan, 'description-text-lg': !showFreePlan }")
              span ライトの機能に加えて
              br
              span.key-color ✔ 職員への連絡
              br
              span.key-color ✔ イベント情報配信
              br
              span.key-color.bold コミュニケーション機能が充実
        .header-line
          .th.resident-limit.no-bottom-border 登録可能利用者数
          .th.resident-limit-count 20人
          .th.plan-detail.no-bottom-border(v-show="showFreePlan")
          .th(:class="{ 'plan-detail': showFreePlan, 'plan-detail-lg': !showFreePlan }")
            .text-center
              span.plan-name {{ planTableModel.lightPlans[0].name }}
              br
              span {{ convertPrice(planTableModel.lightPlans[0].price) }}円/月
              br
              template(v-if="!isCurrentPlusPlan")
                .is-current(v-if="planTableModel.lightPlans[0].isCurrent") 選択中
                button.btn.edit-btn(v-else type="button" @click="onEditPlan(planTableModel.lightPlans[0])") 変更
          .th(:class="{ 'plan-detail': showFreePlan, 'plan-detail-lg': !showFreePlan }")
            .text-center
              span.plan-name {{ planTableModel.basicPlans[0].name }}
              br
              span {{ convertPrice(planTableModel.basicPlans[0].price) }}円/月
              br
              template(v-if="!isCurrentPlusPlan")
                .is-current(v-if="planTableModel.basicPlans[0].isCurrent") 選択中
                button.btn.edit-btn(v-else type="button" @click="onEditPlan(planTableModel.basicPlans[0])") 変更
        .header-line
          .th.resident-limit.no-bottom-border 
          .th.resident-limit-count 50人
          .th.plan-detail.no-bottom-border(v-show="showFreePlan")
            .text-center
              span.plan-name {{ planTableModel.freePlan.name }}
              br
              span {{ convertPrice(planTableModel.freePlan.price) }}円/月
              br
              template(v-if="!isCurrentPlusPlan")
                .is-current(v-if="planTableModel.freePlan.isCurrent") 選択中
                button.btn.edit-btn(v-else type="button" @click="onEditPlan(planTableModel.freePlan)") 変更
          .th(:class="{ 'plan-detail': showFreePlan, 'plan-detail-lg': !showFreePlan }")
            .text-center
              span.plan-name {{ planTableModel.lightPlans[1].name }}
              br
              span {{ convertPrice(planTableModel.lightPlans[1].price) }}円/月
              br
              template(v-if="!isCurrentPlusPlan")
                .is-current(v-if="planTableModel.lightPlans[1].isCurrent") 選択中
                button.btn.edit-btn(v-else type="button" @click="onEditPlan(planTableModel.lightPlans[1])") 変更
          .th(:class="{ 'plan-detail': showFreePlan, 'plan-detail-lg': !showFreePlan }")
            .text-center
              span.plan-name {{ planTableModel.basicPlans[1].name }}
              br
              span {{ convertPrice(planTableModel.basicPlans[1].price) }}円/月
              br
              template(v-if="!isCurrentPlusPlan")
                .is-current(v-if="planTableModel.basicPlans[1].isCurrent") 選択中
                button.btn.edit-btn(v-else type="button" @click="onEditPlan(planTableModel.basicPlans[1])") 変更
        .header-line
          .th.resident-limit.no-bottom-border 
          .th.resident-limit-count 100人
          .th.plan-detail(v-show="showFreePlan")
          .th(:class="{ 'plan-detail': showFreePlan, 'plan-detail-lg': !showFreePlan }")
            .text-center
              span.plan-name {{ planTableModel.lightPlans[2].name }}
              br
              span {{ convertPrice(planTableModel.lightPlans[2].price) }}円/月
              br
              template(v-if="!isCurrentPlusPlan")
                .is-current(v-if="planTableModel.lightPlans[2].isCurrent") 選択中
                button.btn.edit-btn(v-else type="button" @click="onEditPlan(planTableModel.lightPlans[2])") 変更
          .th(:class="{ 'plan-detail': showFreePlan, 'plan-detail-lg': !showFreePlan }")
            .text-center
              span.plan-name {{ planTableModel.basicPlans[2].name }}
              br
              span {{ convertPrice(planTableModel.basicPlans[2].price) }}円/月
              br
              template(v-if="!isCurrentPlusPlan")
                .is-current(v-if="planTableModel.basicPlans[2].isCurrent") 選択中
                button.btn.edit-btn(v-else type="button" @click="onEditPlan(planTableModel.basicPlans[2])") 変更
        .header-line
          .th.resident-limit
          .th.resident-limit-count 101人以上
          .th.plan-detail(v-show="showFreePlan")
            .text-center
              span 有料プランを
              br
              span ご利用ください
          .th(:class="{ 'plan-detail': showFreePlan, 'plan-detail-lg': !showFreePlan }")
            .text-center
              span.plan-name {{ planTableModel.lightPlans[3].name }}
              br
              .is-plus-current(v-if="planTableModel.lightPlans[3].isCurrent") 選択中
              span(v-else) ご相談ください
          .th(:class="{ 'plan-detail': showFreePlan, 'plan-detail-lg': !showFreePlan }")
            .text-center
              span.plan-name {{ planTableModel.basicPlans[3].name }}
              br
              .is-plus-current(v-if="planTableModel.basicPlans[3].isCurrent") 選択中
              span(v-else) ご相談ください
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { PlansGetModel } from "@/commons/services/Plans";

/**
 * ### プラン一覧コンポーネント
 */
@Component
export default class PlanTable extends Vue {
  /** プラン一覧の列情報 */
  @Prop({ required: true })
  planTableModel!: PlanTableModel;

  /** 現在プランが＋プランかどうか */
  @Prop({ required: true })
  isCurrentPlusPlan!: boolean;

  /** フリープランを表示するかどうか */
  @Prop({ required: true })
  showFreePlan!: boolean;

  /**
   * ### 画面表示用の料金に変換する
   *
   * - 3桁ごとに「,」を入れる
   */
  public convertPrice(price: number): string {
    // chromeはtoLocaleString()が実装されているが、実装されていないブラウザがあるかもしれない
    // chrome以外のブラウザ対応になったら要確認or自分で処理を行う
    return price.toLocaleString();
  }

  /**
   * ### プラン変更ボタン押下イベント
   *
   * - 確認ダイアログを表示する
   */
  public onEditPlan(plan: PlanDetail): void {
    this.$emit("edit", plan);
    return;
  }
}

/**
 * ### プランテーブル表示用モデル
 *
 * - プランテーブルの1列分に相当する
 */
export interface PlanTableModel {
  /** フリー */
  freePlan: PlanDetail;
  /** ライト */
  lightPlans: Array<PlanDetail>;
  /** ベーシック */
  basicPlans: Array<PlanDetail>;
}

export interface PlanDetail extends PlansGetModel {
  /** 契約中プランか否か */
  isCurrent: boolean;
}
</script>
<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

#plan-table {
  .plan-table {
    // 画面スクロールを表示させないために、viewサイズからテーブルの高さを動的に設定する
    // view全体から、テーブル要素以外の高さを引けば求められる
    // @include flex-table(1116px);
    @include flex-table(846px);
    // 行数は固定なので、スクロールは非表示にする
    overflow-y: auto;

    margin-bottom: 12px;

    .cancel-btn {
      width: 100px;
    }
    .edit-btn {
      width: 64px;
    }

    $plan-detail-width: 214px;
    $plan-detail-width-lg: 285px;

    .thead {
      .header-line {
        .th {
          // この表は列名部分(グレー)が2次元で表示されるので、罫線を外枠と同じにする
          border-bottom: 1px solid $border-darkgray;
          border-left: 1px solid $border-darkgray;

          &.no-bottom-border {
            border-bottom: 0 !important;
          }
          &.billing-type {
            flex: 1;
            // 登録利用者数と人数の幅を合算した横幅が最低横幅
            min-width: calc(140px + 120px);
          }
          &.free-rate,
          &.plan-name,
          &.plan-description {
            min-width: $plan-detail-width;
            width: $plan-detail-width;
          }
          &.plan-name-lg,
          &.plan-description-lg {
            min-width: $plan-detail-width-lg;
            width: $plan-detail-width-lg;
          }
          &.flat-rate {
            min-width: calc(#{$plan-detail-width} * 2);
            width: calc(#{$plan-detail-width} * 2);
          }
          &.flat-rate-lg {
            min-width: calc(#{$plan-detail-width-lg} * 2);
            width: calc(#{$plan-detail-width-lg} * 2);
          }

          &.plan-description,
          &.plan-description-lg {
            font-weight: inherit !important;
            background-color: rgb(235, 245, 249);

            .description-text {
              margin: 5px;
              min-width: calc(#{$plan-detail-width} - 15px);
              width: calc(#{$plan-detail-width} - 15px);
            }
            .description-text-lg {
              margin: 5px;
              min-width: calc(#{$plan-detail-width-lg} - 15px);
              width: calc(#{$plan-detail-width-lg} - 15px);
            }
            .key-color {
              color: $font-key-color;
            }
            .bold {
              font-weight: bold;
            }
          }

          &.resident-limit {
            flex: 1;
            min-width: 140px;
          }
          &.resident-limit-count {
            min-width: 120px;
            width: 120px;
          }
          &.plan-detail {
            min-width: $plan-detail-width;
            width: $plan-detail-width;
          }
          &.plan-detail-lg {
            min-width: $plan-detail-width-lg;
            width: $plan-detail-width-lg;
          }
          &.plan-detail,
          &.plan-detail-lg {
            text-align: left !important;
            font-weight: normal;
            background-color: $bg-default;

            .plan-name {
              font-weight: bold;
            }
            .is-current {
              // ボタンのheightが42pxなので、考慮した余白を取る
              margin: calc((42px - 24px) / 2) 0;
              font-weight: bold;
              color: $font-key-color;
            }
            .is-plus-current {
              font-weight: bold;
              color: $font-key-color;
            }
          }
        }
      }
      // 最終行に下罫線があると表の枠線が太くなってしまうので非表示にする
      .header-line:last-child {
        .th {
          border-bottom: 0;
        }
      }
    }

    .current-plan {
      color: $font-key-color;
    }
    .inquiry {
      text-align: center;
    }
  }
}
</style>
